<template>
  <div class="bg-white rounded">
    <time-line class="mt-4 col-11 mx-auto px-0">
      <time-line-item
        v-for="(item, index) in history"
        :key="index"
        class="custom-time-line rounded"
      >
        <div class="row">
          <div class="col-12 col-md-2 flex-column d-flex border-right">
            <div class="row">
              <div class="col-12 flex-column d-flex">
                <label class="mb-0 px-2 pt-1 title">{{item.actionType}}</label>
              </div>
              <div class="col-12 mt-2 flex-column d-flex">
                <label class="mb-0 color-gray-6 text-small">Estatus:</label>
                <span class="d-flex align-items-center">
                  <div
                    class="status-indicator"
                    :style="{ backgroundColor: item.color }"
                  >
                    &nbsp;
                  </div>
                  <span class="text">{{ item.text }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 flex-column d-flex">
                <label class="mb-0 color-gray-6 text-small">Usuario:</label>
                <span class="text">{{ item.username }}</span>
              </div>
              <div
                class="col-12 col-md-10 flex-column d-flex mt-2"
                v-if="item.reason"
              >
                <label class="mb-0 color-gray-6 text-small">Razón:</label>
                <span class="d-flex align-items-baseline">
                  <span class="text">{{ item.reason }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <template #icon>
          <em :class="`fas fa-retweet text-white`" class="radius" />
        </template>
        <template #date>
          <div class="date-container">
            <div class="color-black font-16 font-weight-bold fulldate">
              {{ formatDate(item.date) }}
            </div>
            <div class="color-black font-12 fulldate">
              {{ getTimeFromDate(item.date) }}
            </div>
          </div>
        </template>
      </time-line-item>
    </time-line>
    <div class="d-flex justify-content-end">
      <action-button
        type="button"
        text="Cerrar"
        i="fa fa-times-circle"
        variant="outline-success"
        class="ml-2 px-4 mb-3 actionButton"
        @click="close()"
      />
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import ActionButton from "ActionButton";
import moment from "moment";

export default {
  name: "StatusTimeline",
  components: {
    TimeLine,
    TimeLineItem,
    ActionButton
  },
  data: () => ({ items: [] }),
  props: {
    history: { type: Array, default: () => [] }
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale("es")
        .format("DD/MMM/YYYY");
    },
    getTimeFromDate(value) {
      return moment(value).format("h:mm A");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";
.title {
  font-size: 16px;
  font-weight: bold;
  color: map-get($colors, "gray-12");
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text {
  font-size: 16px;
  color: $black_2;
}
.text-small {
  font-size: 14px;
}

.actionButton {
  border-radius: 19px;
}
</style>
